import React from "react";

const TOKEN = /(https?:\/\/[^\s<>()]+[^\s<>().,;:!?'"]|[\w.+-]+@[\w-]+\.[\w.-]+[A-Za-z]|(?:www\.)[\w-]+(?:\.[\w-]+)+(?:\/[^\s<>()]*[^\s<>().,;:!?'"])?)/g;

/** Turns URLs and email addresses inside plain chat text into clickable links. */
export default function Linkify({ text, linkClass = "text-[#FFC93A] underline underline-offset-2 hover:text-white" }: { text: string; linkClass?: string }) {
  const parts = text.split(TOKEN);
  return (
    <>
      {parts.map((p, i) => {
        if (i % 2 === 0) return <React.Fragment key={i}>{p}</React.Fragment>;
        const isEmail = p.includes("@") && !p.startsWith("http");
        const href = isEmail ? `mailto:${p}` : p.startsWith("http") ? p : `https://${p}`;
        return (
          <a key={i} href={href} target={isEmail ? undefined : "_blank"} rel="noopener noreferrer" className={linkClass}>
            {p}
          </a>
        );
      })}
    </>
  );
}
